import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useConfirmationAction } from '../../../../hooks/confirmation-action.hook';
import { KnownDeliveryDtoState, KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMutationMarkDeliveryCollected } from '../../deliveries-details.queries';
import { useWaitForUpdate } from '../../hooks/use-wait-for-update.hook';
import { Delivery } from '../../../models/delivery.model';

export function MarkCollectedModal({
  delivery,
  onAbort,
  onFailed,
  onSuccess
}: {
  delivery: Delivery;
  onAbort(): void;
  onFailed(): void;
  onSuccess(): void;
}) {
  const onSuccessHandler = useWaitForUpdate({
    maximumWaitTime: 1000 * 10,
    onFailed,
    onSuccess,
    predicate: () => delivery.state === KnownDeliveryState.Collected
  });

  const { state, onConfirm } = useConfirmationAction({
    mutationHook: useMutationMarkDeliveryCollected,
    mutationArgs: { deliveryID: delivery.id },
    onSuccess: onSuccessHandler
  });

  return (
    <ConfirmationModal
      title="Mark Collected?"
      content={makeModalContent(delivery.state)}
      actionButton={{
        color: 'primary',
        label: 'Mark Collected'
      }}
      cancelButton={{
        label: 'No'
      }}
      onConfirm={onConfirm}
      onCancel={onAbort}
      {...state}
    />
  );
}

function makeModalContent(status: string): string[] {
  const content = [
    `Marking the delivery Collected is for when you've removed the delivery and given it to the recipient.`
  ];

  if (assertIsIntermediateState(status)) {
    content[0] += ` We'll update the locker state to reflect that it is now empty and the recipients's collection code will no longer work.`;
    content.push(
      `If you've taken it back you should mark the delivery as Retrieved instead or, if it was delivered in error, Cancelled.`
    );
  }

  content.push(`Are you sure?`);

  return content;
}

function assertIsIntermediateState(status: string) {
  return [
    KnownDeliveryDtoState.Delivered,
    KnownDeliveryDtoState.Overdue,
    KnownDeliveryDtoState.RetrievalRequired
  ].includes(status as KnownDeliveryDtoState);
}
